import type { FaireProductEntity } from "../../entity_types/product";

export const p_6gfgmcab9h: FaireProductEntity = {
  token: "p_6gfgmcab9h",
  type: "product",
  name: "Magical Bookmark Set",
  brandToken: "b_dfu92850",
  brandName: "Pippi Post",
  imageUrl:
    "https://cdn.faire.com/fastly/7d69cefd85791b16dc420782a2b37bbd3a1db7003cc4d6f84e7f70c06cd6b6be.jpeg",
  galleryImageUrls: [],
  priceDollars: 2.76,
  description: "",
  tags: [],
  msrpDollars: 5.51,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T22:12:02.463Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
